import React, { useMemo } from 'react'
import { Group } from '@/model/types/goods'
import { goodsShelfStore } from '../../store/goods-shelf'
import { getBEMCls } from '@/utils/classname'

import './good-group.scss'
import { observer } from 'mobx-react'
import DropContent from '@/views/main/modules/goods-manage/goods-storage/goods-library/modules/goods-group/drop-content'
import { MALL_DARG_TYPE } from '../../../mall-shelf'

interface MallGroupItemProps {
    group: Group
    groupArr: Group[]
    groupIndex: number
    secondGroupId: number
    onClick?: (v: Group[], groupIndex: number) => void
    onDrop?: (item: any, groupId: number, secondGroupId: number) => void
}

const MallGroupItem: React.FC<MallGroupItemProps> = observer(props => {
    const getCls = (e?: string, m?: string) => getBEMCls('mall-group', e, m)
    const { group } = props

    const isActive = useMemo(
        () =>
            group.id === goodsShelfStore.groupId ||
            (!!group.secondary_group.length &&
                group.secondary_group.every(i => i.id === goodsShelfStore.secondGroupId)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [group, goodsShelfStore.groupId, goodsShelfStore.secondGroupId],
    )

    return (
        <>
            <div
                className={`${
                    isActive
                        ? group.secondary_group.length
                            ? getCls('item', 'active-second')
                            : getCls('item', 'active')
                        : getCls('item')
                }`}
                onClick={() => {
                    props.onClick && props.onClick(props.groupArr, props.groupIndex)
                    if (!props.group.secondary_group.length) {
                        goodsShelfStore.setActiveGroupId(group.id)
                        goodsShelfStore.setActiveSecondGroupId(0) // 初始化一下,防止在无二级分组的情况下请求二级分组
                    }
                }}
            >
                {!!group.secondary_group.length && !!group.secondary_group[0].id && (
                    <i
                        className={`icon6xiala2-20 iconfont ${getCls('arrow')}`}
                        style={{
                            transform: group.open ? 'rotate(0)' : 'rotate(-90deg)',
                        }}
                    />
                )}
                {group.name}
                <span>{group.goods_num}</span>
            </div>

            <div
                className={getCls('item', 'menu')}
                style={{
                    height: group.open && group.secondary_group[0]?.id ? `${group.secondary_group.length * 70}px` : '0',
                }}
            >
                {!!group.secondary_group.length &&
                    group.secondary_group[0].id &&
                    group.secondary_group.map(second => (
                        <DropContent
                            key={second?.id}
                            type={MALL_DARG_TYPE}
                            onDrop={item => {
                                props.onDrop && props.onDrop(item, group.id || 0, second.id)
                            }}
                        >
                            <div
                                key={second.id}
                                className={`${
                                    goodsShelfStore.secondGroupId === second.id
                                        ? getCls('menu', 'active')
                                        : getCls('menu')
                                }`}
                                onClick={() => {
                                    goodsShelfStore.setActiveGroupId(group.id)
                                    goodsShelfStore.setActiveSecondGroupId(second.id)
                                }}
                            >
                                {second?.name}
                            </div>
                        </DropContent>
                    ))}
            </div>
        </>
    )
})

export default MallGroupItem
